import { render, staticRenderFns } from "./OtherModifications.vue?vue&type=template&id=e289e5d6&scoped=true"
import script from "./OtherModifications.vue?vue&type=script&lang=js"
export * from "./OtherModifications.vue?vue&type=script&lang=js"
import style0 from "./OtherModifications.vue?vue&type=style&index=0&id=e289e5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e289e5d6",
  null
  
)

export default component.exports